import React, { useState, useEffect, useRef } from 'react';
import { GoogleLogin, type CredentialResponse } from '@react-oauth/google';
import { setAuthToken, API_BASE_URL } from '../../api/config';
import { getMe } from '../../api/endpoints';
import { navigateTo } from '../../utils/navigation';

async function handleGoogleLoginSuccess(credentialResponse: CredentialResponse) {
  console.log('[GoogleDebug] handleSuccess called', credentialResponse);
  try {
    if (!credentialResponse.credential) {
      console.error("[GoogleDebug] Google Login: No credential received");
      return;
    }

    console.log('[GoogleDebug] Sending credential to backend');
    const res = await fetch(`${API_BASE_URL}auth/google-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id_token: credentialResponse.credential }),
    });

    if (!res.ok) {
      const errText = await res.text();
      console.error('[GoogleDebug] Google login failed:', res.status, errText);
      throw new Error('Google login failed');
    }

    const data = (await res.json()) as { 'jwt-key'?: string };
    console.log('[GoogleDebug] Backend success, JWT received');
    const token = data['jwt-key'];
    if (!token) throw new Error('Google login failed');
    setAuthToken(token);

    try {
      await getMe();
      console.log('[GoogleDebug] getMe success, navigating to /');
      navigateTo('/');
    } catch (error) {
      console.error("[GoogleDebug] Google Login: Failed to fetch user info", error);
      navigateTo('/');
    }

  } catch (error) {
    console.error('[GoogleDebug] Login Failed (Exception)', error);
  }
}

export default function GoogleLoginButton() {
  const [buttonWidth, setButtonWidth] = useState('340');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        // Cap the width at 340px, but allow it to be smaller
        const newWidth = Math.min(containerWidth, 340);
        setButtonWidth(newWidth.toString());
      }
    };

    // Initial calculation
    handleResize();

    // Add resize listener
    window.addEventListener('resize', handleResize);
    return () => { window.removeEventListener('resize', handleResize); };
  }, []);

  return (
    <div ref={containerRef} className="w-full flex justify-center h-[40px]">
      <GoogleLogin
        onSuccess={handleGoogleLoginSuccess}
        onError={() => {
          console.error('[GoogleDebug] Google Login Component Failed (onError called)');
        }}
        useOneTap
        shape="pill"
        theme="outline"
        size="large"
        text="signin_with"
        width={buttonWidth}
        locale="en_US"
      />
    </div>
  );
}
